import { DiseaseType } from "../../../../../type/Disease.js";
import { medications } from "../config/medicaments.js";
import { createFields } from "../helpers/createFields.js";
import { buildValidationSchema } from "../yup/buildValidationSchema.js";
import "yup";
const fields = createFields({
  hasAllergies: {
    __type: "radioGroup",
    name: "hasAllergies",
    label: "field.has_allergies",
    isRequired: true,
    helperText: "field.has_allergies_helper",
    options: [
      {
        label: "allergies_yes",
        value: "YES"
      },
      {
        label: "allergies_no",
        value: "NO"
      },
      {
        label: "allergies_maybe",
        value: "UNKNOWN"
      }
    ],
    hooks: {
      beforeChange: (value, helpers, _event) => {
        if (value !== "YES") {
          const { value: diseases } = helpers.getFieldProps("diseases");
          const diseasesWithoutAllergies = diseases == null ? void 0 : diseases.filter(
            (disease) => disease.type !== DiseaseType.OTHER_ALLERGIES && disease.type !== DiseaseType.MEDICATION_ALLERGIES
          );
          helpers.setFieldValue("diseases", diseasesWithoutAllergies || []);
        }
      }
    }
  },
  medications: {
    __type: "custom",
    name: "medications",
    label: "field.medications",
    helperText: "field.medications_helper",
    options: medications.map((medication) => ({ label: `option.${medication}`, value: medication }))
  },
  allergyPass: {
    __type: "toggle",
    name: "allergyPass",
    label: "field.allergy_pass",
    helperText: "field.allergy_pass_helper",
    visibleWhen: ({ hasAllergies }) => hasAllergies === "YES"
  }
});
const validationSchema = buildValidationSchema(fields);
export {
  fields as default,
  validationSchema
};
